import { render, staticRenderFns } from "./MongastonAdmin.vue?vue&type=template&id=7565de57&scoped=true&"
import script from "./MongastonAdmin.vue?vue&type=script&lang=js&"
export * from "./MongastonAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MongastonAdmin.vue?vue&type=style&index=0&id=7565de57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565de57",
  null
  
)

export default component.exports